<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/services/api'

const route = useRoute()
const router = useRouter()

const newPassword1 = ref('')
const newPassword2 = ref('')
const errors = ref<Record<string, string[]>>({})
const inFlight = ref(false)

async function handleSubmit() {
  errors.value = {}
  inFlight.value = true

  try {
    await api.post('/password-reset/confirm/', {
      uid: route.params.uidb64,
      token: route.params.token,
      new_password1: newPassword1.value,
      new_password2: newPassword2.value,
    })
    router.push({ name: 'login' })
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as {
        response?: { data?: Record<string, string[]> }
      }
      errors.value = axiosError.response?.data ?? {}
    }
  } finally {
    inFlight.value = false
  }
}
</script>

<template>
  <main class="col mt-3">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <h3>Reset Your Password</h3>
        <p>
          Please enter your new password twice so we can verify you typed it in
          correctly.
        </p>

        <div v-if="errors.detail" class="alert alert-danger" role="alert">
          {{ errors.detail }}
        </div>

        <form @submit.prevent="handleSubmit" id="password-reset-confirm-form">
          <div class="mb-3">
            <label for="new-password1" class="form-label">New password</label>
            <input
              type="password"
              class="form-control"
              id="new-password1"
              v-model="newPassword1"
              required
              :class="{ 'is-invalid': errors.new_password1 }"
            />
            <div class="invalid-feedback" v-if="errors.new_password1">
              {{ errors.new_password1[0] }}
            </div>
          </div>

          <div class="mb-3">
            <label for="new-password2" class="form-label"
              >New password confirmation</label
            >
            <input
              type="password"
              class="form-control"
              id="new-password2"
              v-model="newPassword2"
              required
              :class="{ 'is-invalid': errors.new_password2 }"
            />
            <div class="invalid-feedback" v-if="errors.new_password2">
              {{ errors.new_password2[0] }}
            </div>
          </div>

          <button type="submit" class="btn btn-primary" :disabled="inFlight">
            <span
              v-if="inFlight"
              class="spinner-border spinner-border-sm"
              role="status"
            />
            <template v-else>Reset password</template>
          </button>
        </form>
      </div>
    </div>
  </main>
</template>

<style scoped lang="scss"></style>
